import { HeroSection } from "../components/HeroSection";
import { AIFeaturesSection } from "../components/AIFeaturesSection";
import { TeamCollaborationSection } from "../components/TeamCollaborationSection";
import { WorkflowAutomationSection } from "../components/WorkflowAutomationSection";
import { PricingSection } from "../components/PricingSection";
import { TestimonialsSection } from "../components/TestimonialsSection";
import { CtaSection } from "../components/CtaSection";
import { FeatureGate } from "../components/FeatureGate";

export function HomePage() {
  return (
    <>
      <HeroSection />
      <FeatureGate flag="AI_FEATURES">
        <AIFeaturesSection />
      </FeatureGate>
      <FeatureGate flag="TEAM_COLLABORATION">
        <TeamCollaborationSection />
      </FeatureGate>
      <FeatureGate flag="WORKFLOW_AUTOMATION">
        <WorkflowAutomationSection />
      </FeatureGate>
      <FeatureGate flag="PRICING">
        <PricingSection />
      </FeatureGate>
      <FeatureGate flag="TESTIMONIALS">
        <TestimonialsSection />
      </FeatureGate>
      <FeatureGate flag="CTA_BANNER">
        <CtaSection />
      </FeatureGate>
    </>
  );
}
